// Copyright 2026 - Hewlett Packard Enterprise Company
/* eslint-disable import/prefer-default-export */

/*
 * Flag overrides take absolute precedence over LaunchDarkly responses AND
 * defaults. If a flag key appears here, its value will always be returned
 * regardless of the LD connection state or remotely configured variation.
 *
 * Precedence: override > LD response > default (ldFlagDefaults)
 *
 * Use this for flags that must be locked to a specific value client-side
 * (e.g., during a migration cutover) without waiting for LD targeting
 * changes to propagate.
 */

export const ldFlagOverrides = {
  T_20260429_69543_THEME_VERSION: 8,
};
